import { combineReducers } from 'redux';
export const Account_Connect = 'Account_Connect';
export const Account_disConnect = 'Account_disConnect';
export const Log_In = 'Log_In';
export const Log_Out = 'Log_Out';

const initial_wallet_connect = {

  logincheck: "pending",

  modelpopup: false,
  UserAccountAddr: '',
  UserAccountBal: 0,
  providerss: null,
  Service_Fee_buyer: 0,
  Service_Fee_seller: 0,
  Wen_Bln: 0,
  Accounts: '',
  WalletConnected: '',
  AddressUserDetails: null,
  tokenAddress: {},
  tokenAddressETH: {},
  tokenAddressBSC: {},
  networkoption: {},

  swapFee: 0,
  currency_convertion: 0,
  networkConfiguration:
  {
    currencySymbol: '',
    tokenSymbol: '',
    tokenABI: {},
    tokenAddr: {},
    singleContract: "",
    multipleContract: "",
    trade: "",
    BNBPROVIDER: "",
    networkVersion: '',
    chainId: '',
    Chainid: 0,
  }
}




function wallet_connect_context(state = initial_wallet_connect, action) {
  
  switch (action.type) {
    case Log_In: {
      

      return {
        ...state,
        ...action.Account_Detail
      }
    };
    case Account_Connect: {
      

      return {
        ...state,
        ...action.Account_Detail
      }
    };
    case Account_disConnect:
      return {
        ...state,
        ...initial_wallet_connect,
      };
      case Log_Out: {
        return {
          ...state,
          ...initial_wallet_connect,
          logincheck: 'false',
        };
      }
    default: {
      
      return state;

    }
  }
}
const birdApp = combineReducers({
  wallet_connect_context
});

export default birdApp;